import { InputLabel, TextField } from "@suraasa/placebo-ui"
import clsx from "clsx"
import { useEffect, useState } from "react"

export enum AddressTypeEnum {
  COUNTRY = "country",
  STATE = "administrative_area_level_1",
  DISTRICT = "administrative_area_level_3",
  CITY = "locality",
  AREA = "sublocality_level_1",
  POLITICAL = "political",
  POSTALCODE = "postal_code",
}

export type AddressComponents = {
  longText: string
  shortText: string
  types: AddressTypeEnum[]
}[]

export type GoogleLocationSelectValue = {
  fullWidth?: boolean
  className?: string
  placeHolder?: string
  onChange?: (addressComponents: AddressComponents) => void
  label?: string
  required?: boolean
  error?: boolean
  helperText?: string
  value?: {
    country?: string | null
    state?: string | null
  }
}

const GoogleLocationSelect = ({
  value,
  className,
  onChange,
  placeHolder,
  fullWidth,
  label,
  required,
}: GoogleLocationSelectValue) => {
  const [showPicker, setShowPicker] = useState(false)

  const handlePlaceChange = (e: any) => {
    if (onChange) onChange(e.target.value?.addressComponents || [])
  }

  const countries: string[] = []

  useEffect(() => {
    if (!value) setShowPicker(true)
  }, [value])

  useEffect(() => {
    const picker = document.getElementById("place-picker")

    if (picker) {
      picker.addEventListener("gmpx-placechange", e => {
        handlePlaceChange(e)
      })
    }
  }, [])

  return (
    <div className={clsx("flex flex-col px-px", className)}>
      <InputLabel label={label} required={required} />

      {!showPicker && value && (
        <TextField
          readOnly
          onClick={() => {
            setShowPicker(true)
          }}
          value={[value.state, value.country].filter(Boolean).join(", ")}
        />
      )}
      {/* https://github.com/googlemaps/extended-component-library/blob/HEAD/src/place_picker/README.md */}
      {/* @ts-expect-error We don't have types for this because this is a web component */}
      <gmpx-place-picker
        id="place-picker"
        class={clsx(
          "w-full rounded-md border border-onSurface-900 [&>.container]:text-[1rem]",
          {
            "max-w-[298px]": !fullWidth,
            hidden: !showPicker,
          }
        )}
        country={countries}
        placeholder={placeHolder}
      />
    </div>
  )
}

export default GoogleLocationSelect
